import dayjs from 'dayjs'
import { formatDate, formatDateTimeMinus } from 'src/variable/constant'

export interface MetricPeriod {
	start?: string
	end?: string
	label?: string
}

export const TIME_RANGE_FALLBACK = 'Time range unavailable'

const parseDate = (value?: string) => {
	if (!value) return null

	const normalizedValue = value.replace(' UTC', '')
	const parsed = dayjs(normalizedValue)
	return parsed.isValid() ? parsed : null
}

export const formatMetricDateTime = (value?: string) => {
	const parsed = parseDate(value)
	return parsed ? parsed.format(formatDateTimeMinus) : TIME_RANGE_FALLBACK
}

export const formatMetricDate = (value?: string) => {
	const parsed = parseDate(value)
	return parsed ? parsed.format(formatDate) : TIME_RANGE_FALLBACK
}

export const formatMetricRange = (period?: MetricPeriod) => {
	if (!period?.start || !period?.end) {
		return TIME_RANGE_FALLBACK
	}

	const start = parseDate(period.start)
	const end = parseDate(period.end)

	if (!start || !end) {
		return TIME_RANGE_FALLBACK
	}

	const startHasTime = period.start.length > 10
	const endHasTime = period.end.length > 10

	if (start.isSame(end, 'day')) {
		if (startHasTime && endHasTime) {
			return `${start.format(formatDate)} (${start.format('HH:mm')} - ${end.format('HH:mm')})`
		}

		return start.format(formatDate)
	}

	return `${start.format(formatDate)} - ${end.format(formatDate)}`
}
